import CartQuery from 'Query/Cart.query';
import CheckoutQuery from 'Query/Checkout.query';
import ConfigQuery from 'Query/Config.query';
import RegionQuery from 'Query/Region.query';
import ReviewQuery from 'Query/Review.query';
import { ConfigDispatcher as SourceConfigDispatcher } from 'SourceStore/Config/Config.dispatcher';

/** @namespace PeggysagePwa/Store/Config/Dispatcher */
export class ConfigDispatcher extends SourceConfigDispatcher {
    /**
     * Override: add getCheapestShippingMethod()
     * @returns {*[]}
     */
    prepareRequest() {
        return [
            RegionQuery.getCountriesQuery(),
            ReviewQuery.getRatingQuery(),
            ConfigQuery.getQuery(),
            ConfigQuery.getCheckoutAgreements(),
            ConfigQuery.getCurrencyData(),
            ConfigQuery.getCurrencyRates(),
            CartQuery.getCartDisplayConfig(),
            CheckoutQuery.getCheapestShippingMethod()
        ];
    }
}

export default new ConfigDispatcher();
